import { useEffect } from 'react';
import useAuth from './useAuth';
import { AuthUser } from '../types/auth';

const useAuthInit = () => {
  const { signIn, initializeUser } = useAuth();

  useEffect(() => {
    const initialize = async () => {
      const localUserStr = localStorage.getItem('user');
      const storedUser = localUserStr ? (JSON.parse(localUserStr) as AuthUser) : null;
      const storedAccessToken = localStorage.getItem('access_token');

      try {
        if (storedUser && storedAccessToken) {
          signIn(storedUser, '/dashboard');
        } else {
          initializeUser();
        }
      } catch (err) {
        console.error('Auth initialization error:', err);
        initializeUser();
      }
    };

    initialize();
  }, []);
};

export default useAuthInit;
